import { render, staticRenderFns } from "./resultPay.vue?vue&type=template&id=05d6f4ed&scoped=true&"
import script from "./resultPay.vue?vue&type=script&lang=js&"
export * from "./resultPay.vue?vue&type=script&lang=js&"
import style0 from "./resultPay.vue?vue&type=style&index=0&id=05d6f4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6f4ed",
  null
  
)

export default component.exports